const _ = require('lodash');

module.exports = function (FiltersService) {
	return {
		restrict: 'E',
		scope: {
			filterData: '='
		},
		link(scope) {
			scope.selectedAlphabet = null;
			scope.filtersService = FiltersService;

			scope.init = function () {
				scope.alphabets = [];
				const alphabets = '#ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

				scope.filter = scope.filtersService.groupByAlphabet(scope.filterData.Results);

				_.each(alphabets, function (letter) {
					scope.alphabets.push({
						letter,
						isSelectable: !!scope.filter[letter]
					});
				});

				scope.selectedAlphabet = _.keys(scope.filter)[0];
			};

			//Filter by alphabet
			scope.filterByAlphabet = function ({ isSelectable, letter }) {
				if (isSelectable) {
					scope.selectedAlphabet = letter;
				}
			};

			scope.applySelectedFilter = function ({ Term }) {
				scope.filtersService.applyFilter(scope.filterData.Name, {
					Term
				});
			};

			scope.$watch('filterData', function (value) {
				if (value) {
					scope.init();
				}
			});
		},
		template: require('./filter-brand-template.html')
	};
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/filters/advance-filter/filter-brand-directive.js
 **/